import type React from 'react';
import { useContext } from 'react';
import { TooltipBubble } from '../TooltipBubble';
import { TextButton, type TextLargeParagraphTitleProps } from '../Typography';
import { NavbarContext } from './NavbarContext';

export interface NavbarPageDetailsProps {
  title: string;
  description?: React.ReactNode;
}

type TextProps = Pick<TextLargeParagraphTitleProps, 'ellipsis' | 'label'>;

const Text = ({ label, ellipsis }: TextProps) => {
  const { theme: navbarTheme } = useContext(NavbarContext);
  return (
    <TextButton
      label={label}
      color={
        navbarTheme === 'dark' ? 'text-ds-accent3-100' : 'text-ds-natural-600'
      }
      ellipsis={ellipsis}
    />
  );
};

export const Title = ({ label }: Pick<TextProps, 'label'>) => {
  return (
    <TooltipBubble
      placement="top"
      title={label}
    >
      <div className="flex">
        <Text
          ellipsis
          label={label}
        />
      </div>
    </TooltipBubble>
  );
};

export const NavbarPageDetails = ({
  title,
  description,
}: NavbarPageDetailsProps) => {
  return (
    <div className="leading-4 h-full flex flex-col gap-1 justify-center mx-2.5 w-[150px]">
      <Title label={title} />
      {description}
    </div>
  );
};
